import React from 'react'
import Menu from '../Menu'

export const Home = () => {
  return (
    <div>
      <Menu />
    </div>
  )
}
